export const superNavigation: any[] = [
  {
    id: 'resources',
    title: 'resources',
    subtitle: '',
    type: 'group',
    icon: 'heroicons_outline:home',
    classes: {
      wrapper: 'hidden',
    },
    children: [
      {
        id: 'records.companies',
        title: 'companies',
        titlePt: 'empresas',
        titleEn: 'companies',
        titleEs: 'empresas',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/companies',
      },
      {
        id: 'integrations',
        title: 'integrations',
        titlePt: 'integrações',
        titleEn: 'integrations',
        titleEs: 'integraciones',
        type: 'collapsable',
        icon: 'mat_outline:sync',
        children: [
          {
            id: 'integrations.integrations',
            title: 'integrations',
            titlePt: 'integrações',
            titleEn: 'integrations',
            titleEs: 'integraciones',
            type: 'basic',
            icon: 'mat_outline:sync',
            link: '/integrations',
          },
          {
            id: 'integrators',
            title: 'integrators',
            titlePt: 'integradores',
            titleEn: 'integrators',
            titleEs: 'integradores',
            type: 'basic',
            icon: 'mat_outline:account_box',
            link: '/integrators',
          },
        ],
      },
      {
        id: 'records',
        title: 'records',
        titlePt: 'cadastros',
        titleEn: 'records',
        titleEs: 'registros',
        type: 'collapsable',
        icon: 'heroicons_outline:rectangle-group',
        children: [
          {
            id: 'records.organizations',
            title: 'organizations',
            titlePt: 'organizações',
            titleEn: 'organizations',
            titleEs: 'organizaciones',
            type: 'basic',
            icon: 'heroicons_outline:building-library',
            link: '/organizations',
          },
          {
            id: 'records.users',
            title: 'users',
            titlePt: 'usuários',
            titleEn: 'users',
            titleEs: 'usuarios',
            type: 'basic',
            icon: 'heroicons_outline:user',
            link: '/users',
          },
        ],
      },
    ],
  },
];
